import { createContext, useContext } from "react";

export interface DialogStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const DialogContext = createContext<DialogStore | undefined>(undefined);

export const useDialogContext = () => {
  return useContext(DialogContext);
};
